<template>
  <div>
    <ul class="nav nav-tabs">
      <li
        v-for="tab in tabs"
        :class="{active: tab === selectedTab}"
        :key="tab"
        @click="selectTab(tab)"
      >
        <a> {{ tab }} </a>
      </li>
    </ul>
    <div class="card" style="margin: none;">
      <div class="card-content">
        <slot :name="selectedTab">
            Empty tab
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: []
    }
  },

  data: () => ({
    selectedTab: null,
  }),

  mounted() {
    if (this.tabs.length > 0) {
      this.selectedTab = this.tabs[0]
    }
  },

  methods: {
    selectTab(tab) {
      this.selectedTab = tab
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  margin-top: 0;
}

.nav {
  padding: 0;
}

.nav-tabs {
  background: none;
  cursor: default;

  >li {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background: #1f2848;
    margin-right: 10px;
    box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.14);

    &>a{
      color: white !important;
      padding: none;
    }

    &.active {
      background: white;
      z-index: 2;

      &::after {
        content: '';
        position: absolute;
        background: white;

      }

      &>a{
        color: #e2147e !important;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// Tabs.vue?5c56b949